module.exports = __webpack_public_path__ + "img/signupBottom.41e95ca4.svg";